<template>
  <div>
    <p>
      تعقيب معاملات بصفة
    </p>
    
    <b-form-group v-slot="{ ariaDescribedby }">
      <b-form-radio-group
        v-model="model"
        :options="options"
        :aria-describedby="ariaDescribedby"
        button-variant="outline-primary"
        name="radio-btn-outline"
        buttons
      />
    </b-form-group>
  </div>

</template>

<script>
import { BFormGroup, BFormRadioGroup } from "bootstrap-vue";
import AuthHelpers from "@/utils/auth-helpers";
export default {
  components: {
    BFormGroup,
    BFormRadioGroup,
  },
  data() {
    return {
      listOptions:[],
      model: "all",
    };
    
  },

  computed: {
    options() {
      if(AuthHelpers.getTransactionRoles().some(item => item.slug === "employee") ){
        let result = AuthHelpers.getTransactionRoles().find(obj => obj["slug"] === "employee");
        this.listOptions.push({ text: "موظف", value: result.id  })
      }
      if(AuthHelpers.getTransactionRoles().some(item => item.slug === "head_of_regulation_and_governance"))
      {
        let result = AuthHelpers.getTransactionRoles().find(obj => obj["slug"] === "head_of_regulation_and_governance");
        this.listOptions.push({ text: "رئيس دائرة", value: result.id  })
      }
      if(AuthHelpers.getTransactionRoles().some(item => item.slug === "central_employee")){
        let result = AuthHelpers.getTransactionRoles().find(obj => obj["slug"] === "central_employee");
        this.listOptions.push({ text: 'موظف مركزي', value: result.id })
      }
      if (AuthHelpers.getTransactionRoles().some(item => item.slug === "director_of_social_affairs_and_labor")){
        let result = AuthHelpers.getTransactionRoles().find(obj => obj["slug"] === "director_of_social_affairs_and_labor");
        this.listOptions.push({ text: "مدير الشؤون الاجتماعية والعمل", value: result.id })
      }
      if(AuthHelpers.getTransactionRoles().some(item => item.slug === "director_of_ngos")){
        let result = AuthHelpers.getTransactionRoles().find(obj => obj["slug"] === "director_of_ngos");
        this.listOptions.push({ text: 'مدير المنظمات غير الحكومية', value: result.id })
      }
      return this.listOptions  ;
    },
  },

  watch: {
    model(val) {
      this.$emit("filterChanged", val);
    },
  },
};
</script>
